import React from "react";

/**
 * The device shell. Drawn rather than photographed: a real bezel, a real
 * dynamic island, a specular highlight raking across the glass. Static
 * screenshots are what every app landing page does; a running interface is
 * the thing worth scrolling to.
 */
export default function Phone({ children, tint, label }) {
  return (
    <div className="phone" style={tint ? { "--tint": tint } : undefined} aria-label={label} role="img">
      <div className="phone__frame">
        <div className="phone__glass">
          <div className="phone__island" aria-hidden="true" />
          <div className="phone__status" aria-hidden="true">
            <span>9:41</span>
            <span className="phone__status-right">
              <i className="sig">
                <b /><b /><b /><b />
              </i>
              <i className="wifi" />
              <i className="batt" />
            </span>
          </div>
          <div className="phone__screen">{children}</div>
          <div className="phone__home" aria-hidden="true" />
        </div>
        <span className="phone__sheen" aria-hidden="true" />
      </div>
      <span className="phone__shadow" aria-hidden="true" />
    </div>
  );
}
